import { Trans, t } from '@lingui/macro';
import { Alert, Button, Dialog, DialogFooter, DialogHeader, Loader, Typography, useToast, } from '@pocketlaw/tetris';
import { useRecoverFeedback } from './useRecoverFeedback';
import { StyledDialogContent } from './styled';
export function RecoverDialog(props) {
    const { onClose, feedbackId } = props;
    const { recoverFeedback, error, loading } = useRecoverFeedback();
    const { addToast } = useToast();
    const handleRecoverFeedback = () => recoverFeedback({ feedbackId }).then(() => {
        onClose();
        addToast({
            appearance: 'info',
            title: t({
                message: 'The issue has been recovered',
                comment: 'Plai Review - Recover dialog - toast message - issue was recovered',
            }),
        });
    });
    return (<Dialog onClose={onClose}>
      <DialogHeader title={<Trans comment="Plai Review - Recover dialog - header title">Recover issue</Trans>}/>
      <StyledDialogContent>
        {error && <Alert appearance="danger" title="TODO: TECH-7637" message="Add error message"/>}
        <Typography>
          <Trans comment="Plai Review - Recover dialog - description">
            Do you want to recover this issue? This will bring back into the review process.
          </Trans>
        </Typography>
      </StyledDialogContent>
      <DialogFooter>
        <Button type="button" appearance="secondary" onClick={onClose} disabled={loading}>
          <Trans comment="Plai Review - Recover dialog - cancel button - label">Cancel</Trans>
        </Button>
        <Button type="button" appearance="primary" onClick={handleRecoverFeedback} disabled={loading}>
          <Trans comment="Plai Review - Recover dialog - submit button - label">Recover</Trans>
          {loading && <Loader />}
        </Button>
      </DialogFooter>
    </Dialog>);
}
